import styled from 'styled-components'

import MEDIA from 'constants/media'
import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'

export const Wrap = styled.div`
  margin: 10px 10px 20px;
  text-align: center;
  max-width: 480px;
  width: 100%;
  ${MEDIA.small`
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  `}
`

export const ThumbnailWrap = styled.div`
  border: 2px solid ${COLORS.BORDERS};
  padding: 10px;
  width: 100%;
  max-width: 300px;
  max-height: 300px;
  margin: auto;
  img {
    width: auto;
    max-width: 280px;
    max-height: 280px;
  }
  ${MEDIA.small`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 300px;
    height: 300px;
  `}
`

export const Title = styled.span`
  text-align: center;
  margin: auto;
  display: block;
  font-weight: ${FONTS.WEIGHTBOLD};
  font-size: ${FONTS.FONTLARGE};
  margin-top: 20px;
  word-break: break-word;
  a:link, a:visited {
    text-decoration: none;
  }
`
